import {createSelector} from 'reselect';
import {getExperiment} from '../../ExperimentSelectors';

export default createSelector(
  [getExperiment],
  experiment => (experiment?.apm_redesign_wave_03 === 'v1|checkout_btn_sticky_and_jump_hidden_submit'),
);
